import { cn } from "@/core/helpers/cn";
import { PhoneSystemAppsListEnum } from "@/domains/phone/constants/phoneSystemAppsListEnum";

type Props = {
  id: number;
  Icon: (props: { className?: string }) => JSX.Element;
  onClick: (event: React.MouseEvent<HTMLElement>, appId: PhoneSystemAppsListEnum) => void;
  className?: string;
  background?: string;
};

export default function PhoneSystemAppIcon({ id, Icon, onClick, className, background }: Props) {
  return (
    <button
      className={cn("flex justify-center items-center size-15 rounded-[1.25rem]", className)}
      style={{ background }}
      onClick={(event) => onClick(event, id)}
      type="button"
    >
      <Icon className="size-6.5" />
    </button>
  );
}
